// eslint-disable-next-line import/no-anonymous-default-export
export default {
  h1: {
    fontWeight: 500,
    fontSize: '35px',
    lineHeight: '40px'
  },
  h2: {
    fontWeight: 500,
    fontSize: '29px',
    lineHeight: '32px'
  },
  h3: {
    fontWeight: 500,
    fontSize: '24px',
    lineHeight: '28px',
    color: process.env.REACT_APP_H3_FONT
  },
  h4: {
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '24px',
  },
  h5: {
    fontSize: '18px',
    lineHeight: '20px',
    color:process.env.REACT_APP_H5_FONT
  },
  h6: {
    fontWeight: 400,
    color: '#242424',
    fontSize: '14px',
    lineHeight: '22px',
    '&:hover' :{
      color:process.env.REACT_APP_H6_FONTHOVER,
    }
  },
  subtitle1: {
    fontSize: '16px',
    lineHeight: '25px'
  },
  subtitle2: {
    fontWeight: 400,
    fontSize: '14px'
  },
  body1: {
    fontSize: '14px'
  },
  body2: {
    fontSize: '14px'
  },
  button: {
    fontSize: '14px'
  },
  caption: {
    fontSize: '12px'
  },
  overline: {
    fontSize: '12px',
    fontWeight: 500,
    textTransform: 'uppercase'
  }
};
